import { render, staticRenderFns } from "./JobOpeningDetails.vue?vue&type=template&id=832877a4"
import script from "./JobOpeningDetails.vue?vue&type=script&lang=js"
export * from "./JobOpeningDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports